<div class="p-container p-5 relative">

  <ng-container *ngIf="loading">
      <div class="flex justify-center items-center py-20 min-h-[50vh]">
          <i class="pi pi-spin pi-spinner text-3xl text-gray-400"></i>
      </div>
  </ng-container>

  <ng-container *ngIf="!loading && bmiHistoryData">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-2">

          <div class="col-span-5">
              <main-bmi-card
                  [bmi]="bmiHistoryData.latest_bmi"
                  [change]="bmiHistoryData.progress_from_last_bmi"
                  [isPositive]="bmiHistoryData.is_positive"
                  [date]="bmiHistoryData.date"
                  [weight]="bmiHistoryData.weight"
                  [height]="bmiHistoryData.height">
              </main-bmi-card>
          </div>

          <div class="col-span-7">
              <patient-bmi-graph></patient-bmi-graph>
          </div>

      </div>

      <div class="mt-8">
          <patient-bmi-history-list [history]="bmiHistoryData.bmi_history"></patient-bmi-history-list>
      </div>
  </ng-container>

  <ng-container *ngIf="!loading && !bmiHistoryData">
      <div class="text-center p-8 text-gray-500">
          No BMI history records found.
      </div>
  </ng-container>

</div>
